import { makeAutoObservable, runInAction } from 'mobx';
import { apiServiceV2 } from '../../services/apiService';
import { globalStore } from '../../global.store';
import { formatDate, transformDataUserEvent } from '../../helpers/utils';

class Calendarium {
  selectedDate: any = '';

  eventsCountByDay: any = {};

  checkInDay: string = formatDate(new Date().toString());

  checkOutDay: string = formatDate(
    new Date(new Date().setDate(new Date().getDate() + 1)),
  );

  // checkOutDay: string = formatDate(new Date().toString());
  spaceEvents: any = [];

  meetingEvents: any = [];

  constructor() {
    makeAutoObservable(this);
  }

  get events() {
    return [...this.spaceEvents, ...this.meetingEvents];
  }

  set events(data: any) {
    this.spaceEvents = data;
  }

  selectDay = (day: any) => {
    this.selectedDate = day;
  };

  initCalendarStor = async () => {
    await this.getEventsCountByDay();
    await this.getUpcomingEvents();
    await this.getUserEvents();
  };

  getEventsByDate = async (day: string) => {
    const response = await apiServiceV2.getEvents({ eventDay: day });
    if (!response.error) {
      runInAction(() => (this.spaceEvents = response.data.items));
    }
  };

  getUserEvents = async (date: any = '') => {
    try {
      const query: any = {};
      date && (query.date = date);
      const {
        data: { result },
      } = await apiServiceV2.getUserEvents(query);
      let rooms: any = [];
      Object.keys(result).forEach((item: string) => {
        !date &&
          (this.eventsCountByDay = {
            ...this.eventsCountByDay,
            [item]: this.eventsCountByDay[item]
              ? this.eventsCountByDay[item] + 1
              : 1,
          });

        rooms = result[item].map(transformDataUserEvent);
      });
      this.meetingEvents = rooms;
    } catch (error) {}
  };

  handleDateChange = async (e: any) => {
    const formatDateString = formatDate(e as string);
    if (this.selectedDate === formatDateString) {
      this.removeState();
      await this.initCalendarStor();
      this.selectDay('');
    } else {
      this.selectDay(formatDateString);
      await this.getEventsByDate(formatDateString);
      await this.getUserEvents(formatDateString);
    }
  };

  getEventsCountByDay = async () => {
    const res = await apiServiceV2.getEventsCount();
    if (!res.error) runInAction(() => (this.eventsCountByDay = res.data.items));
  };

  getUpcomingEvents = async () => {
    const response = await apiServiceV2.getEvents();
    if (!response.error) {
      runInAction(
        () =>
          (this.spaceEvents = response.data.items.map((item: any) => ({
            ...item,
            name: item.events[0].eventName,
          }))),
      );
    }
  };

  setCheckInDay = (date: string) => {
    this.checkInDay = date;
  };

  setCheckOutDay = (date: string) => {
    this.checkOutDay = date;
  };

  onLikeRoom = async (roomId: string | undefined) => {
    const res = await apiServiceV2.handleLikeRoom(Number(roomId));
    if (!res.error) {
      this.spaceEvents = this.spaceEvents.map((event: any) => {
        if (event.id === roomId) {
          return {
            ...event,
            isLiked: res.data.isLiked === 1,
          };
        }
        return event;
      });
    } else {
      globalStore.setToasts(true, 'something_went_wrong');
    }
  };

  removeState = () => {
    this.eventsCountByDay = {};
    this.spaceEvents = [];
    this.meetingEvents = [];
  };
}
export const calendariumStore = new Calendarium();
